import { HotelListPage } from './app/pages/modal-screens/hotel-list/hotel-list.page';
import { HotelDetailsComponent } from './app/pages/modal-screens/hotel-details/hotel-details.component';
import { CompetitionTravelUpdateModalPage } from './app/pages/modal-screens/competition-travel-update/competition-travel-update.page';
import { CompetitionFormModalPage } from './app/pages/modal-screens/competition-form/competition-form.page';
import { TournamentsViewFilterPage } from './app/pages/competition/tournaments-view-filter/tournaments-view-filter.page';
import { BookingDetailsPage } from './app/pages/booking/booking-details/booking-details.page';
import { CommonPullupMenuModule } from './app/pages/modal-screens/common-pullup-menu/common-pullup-menu.module';
import { AboutPage } from './app/pages/about/about.page';
import { BookingHomePage } from './app/pages/booking/booking-home/booking-home.page';
import { ChangePasswordPage } from './app/pages/change-password/change-password.page';
import { CompetitionDetailsPage } from './app/pages/competition/competition-details/competition-details.page';
import { CompetitionFilterPage } from './app/pages/competition/competition-filter/competition-filter.page';
import { CompetitionLeaderboardPage } from './app/pages/competition/competition-leaderboard/competition-leaderboard.page';
import { CompetitionLeagueLeaderboardPage } from './app/pages/competition/competition-league-leaderboard/competition-league-leaderboard.page';
import { CompetitionLeagueLowestPage } from './app/pages/competition/competition-league-lowest/competition-league-lowest.page';
import { CompetitionLeagueMenuPage } from './app/pages/competition/competition-league-menu/competition-league-menu.page';
import { CompetitionLeagueScorecardPage } from './app/pages/competition/competition-league-scorecard/competition-league-scorecard.page';
import { CompetitionListPage } from './app/pages/competition/competition-list/competition-list.page';
import { CompetitionPlayersPage } from './app/pages/competition/competition-players/competition-players.page';
import { CompetitionPrizesPage } from './app/pages/competition/competition-prizes/competition-prizes.page';
import { CompetitionScoringPage } from './app/pages/competition/competition-scoring/competition-scoring.page';
import { CompetitionSponsorsPage } from './app/pages/competition/competition-sponsors/competition-sponsors.page';
import { CompetitionTeamsPage } from './app/pages/competition/competition-teams/competition-teams.page';
import { CoursesModalPage } from './app/pages/competition/competitions-modal/courses-modal/courses-modal.page';
import { DescriptionModalPage } from './app/pages/competition/competitions-modal/description-modal/description-modal.page';
import { FullInfoModalPage } from './app/pages/competition/competitions-modal/full-info-modal/full-info-modal.page';
import { RulesModalPage } from './app/pages/competition/competitions-modal/rules-modal/rules-modal.page';
import { ContactUsPage } from './app/pages/contact-us/contact-us.page';
import { FaqPage } from './app/pages/faq/faq.page';
import { FeedbackPage } from './app/pages/feedback/feedback.page';
import { ForgotPasswordPage } from './app/pages/forgot-password/forgot-password.page';
import { HandicapHistoryPage } from './app/pages/handicap-history/handicap-history.page';
import { HelpContentPage } from './app/pages/help-content/help-content.page';
import { CountryListPage } from './app/pages/modal-screens/country-list/country-list.page';
import { PlayerListPage } from './app/pages/modal-screens/player-list/player-list.page';
import { NotificationsPage } from './app/pages/notifications/notifications.page';
import { PlayerHomePage } from './app/pages/player-home/player-home.page';
import { ProfilePage } from './app/pages/profile/profile.page';
import { SettingsPage } from './app/pages/settings/settings.page';
import { SignInPage } from './app/pages/sign-in/sign-in.page';
import { SignUpPage } from './app/pages/sign-up/sign-up.page';
import { TabsPage } from './app/pages/tabs/tabs.page';
import { EditTeeTimeSettingsPageModule } from './app/pages/modal-screens/edit-teetime-settings/edit-teetime-settings.module';
import { ClubMembershipListPage } from './app/pages/modal-screens/club-membership-list/club-membership-list';
import { CompetitionTeamExpandLogo } from './app/pages/competition/competition-teams-details/competition-team-expand-logo/competition-team-expand-logo';
import { NewsDetailsComponent } from './app/pages/news/news-details/news-details.component';
import { PromoAdsDetailsComponent } from './app/pages/promo-ads/promo-ads-details/promo-ads-details.component';
import { TaxEinvoicingInfoPage } from './app/pages/profile/tax-einvoicing-info/tax-einvoicing-info.page';
import { OrganizerListPage } from './app/pages/normalgame/organizer-list/organizer-list.page';
import { CompetitionHandicapUploadModalPage } from './app/pages/modal-screens/competition-handicap-upload/competition-handicap-upload.page';

/**
 * Created by ashok on 22/11/16.
 */
export const MY_PAGES = [AboutPage];
export const PLAYER_MODULE_PAGES = [
  AboutPage,
  ChangePasswordPage,
  CompetitionDetailsPage,
  CompetitionFilterPage,
  CompetitionLeaderboardPage,
  CompetitionLeagueLeaderboardPage,
  BookingHomePage,
  CompetitionLeagueLowestPage,
  CompetitionLeagueMenuPage,
  CompetitionLeagueScorecardPage,
  CompetitionListPage,
  CompetitionPlayersPage,
  CompetitionPrizesPage,
  CompetitionScoringPage,
  CompetitionSponsorsPage,
  CompetitionTeamsPage,
  CoursesModalPage,
  DescriptionModalPage,
  FullInfoModalPage,
  RulesModalPage,
  ContactUsPage,
  FaqPage,
  FeedbackPage,
  ForgotPasswordPage,
  HandicapHistoryPage,
  HelpContentPage,
  CountryListPage,
  PlayerListPage,
  NotificationsPage,
  PlayerHomePage,
  ProfilePage,
  SettingsPage,
  SignInPage,
  SignUpPage,
  TabsPage,
  ClubMembershipListPage,
  CompetitionTeamExpandLogo,
  NewsDetailsComponent,
  PromoAdsDetailsComponent,
  BookingDetailsPage,
  TournamentsViewFilterPage,
  CompetitionFormModalPage,
  CompetitionHandicapUploadModalPage,
  CompetitionTravelUpdateModalPage,
  HotelDetailsComponent,
  HotelListPage,
  // OrganizerListPage,
  // TaxEinvoicingInfoPage
];

export const MODAL_PAGES = [CommonPullupMenuModule, EditTeeTimeSettingsPageModule];
